<template>
  <div>
    <span
      class="has-text-grey"
      style="margin-left: 1.5em; margin-right: 3.5em; fontsize: 14px; margin-bottom: 1em"
    >
      {{ setting.label || name }}
    </span>

    <el-button
      :disabled="setting.disabled ? true : false"
      :type="setting.buttonType ? setting.buttonType : ''"
      :size="setting.size ? setting.size : ''"
      @click="setting.onClick"
    >
      {{ setting.text }}
    </el-button>

    <Tooltip :label="setting.label || name" :content="setting.detail" />
  </div>
</template>

<script>
/**
 * Button SmartField - Renders an action button for triggering custom functions.
 *
 * @component
 * @description Displays a button that executes a custom onClick handler from the setting configuration.
 * Unlike other SmartFields, this doesn't directly edit a value but provides an action trigger.
 * Useful for actions like testing connections, fetching data, or opening dialogs.
 *
 * @prop {Object} value - Parent object containing the setting value
 * @prop {Object} setting - Field configuration object
 * @prop {string} [setting.label] - Display label before the button (defaults to name)
 * @prop {string} [setting.detail] - Tooltip text explaining the button action
 * @prop {string} setting.text - Button text to display
 * @prop {Function} setting.onClick - Function to execute when button is clicked
 * @prop {string} [setting.buttonType] - Button type ('primary', 'success', 'warning', 'danger', 'info', 'text')
 * @prop {string} [setting.size] - Button size ('medium', 'small', 'mini')
 * @prop {boolean} [setting.disabled] - If true, disables the button
 * @prop {*} [setting.default] - Default value if not set
 * @prop {string} name - Property key in the value object
 *
 * @example
 * <Button
 *   :value="config"
 *   :setting="{
 *     label: 'Connection Test',
 *     text: 'Test Connection',
 *     buttonType: 'primary',
 *     onClick: () => testApiConnection()
 *   }"
 *   name="testButton"
 * />
 */
import Tooltip from "../Tooltip.vue";
export default {
  components: { Tooltip },
  props: ["value", "setting", "name"],
  mounted() {
    if (this.value[this.name] == null) {
      if (this.setting.default != null) {
        this.$set(this.value, this.name, this.setting.default);
      } else {
        this.$set(this.value, this.name, null);
      }
    }
  },
};
</script>
